module.exports = __webpack_public_path__ + "img/4_69.e5db96ab.png";